<template>
  <div id="wrapper" class="page">
    <div id="content-wrapper">
      <div class="container-fluid" style="overflow:auto; min-height: 700px;">

        <div class="row" style="margin-left:1px;">
          <button v-if="director_add" class="btn btn-info mb-2 mr-2" @click.prevent="createPitchModal">
            <i class="fas fa-plus"></i> Add Director
          </button>
          &nbsp;
          <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" @input="onChangePagination"
            aria-controls="my-table" size="sm" class="my-0 mt-1">
          </b-pagination>
          <p style="margin-top: 8px; margin-left: 3px; color: #027bff;">Total: {{ totalRows }}</p>
          <div style="flex-grow: 1" class="text-center"></div>
          <button v-if="director_report" class="btn btn-success mb-2 mr-3" @click.prevent="exportReport">
            <i class="fas fa-file-excel pr-1"></i> Report
          </button>

        </div>
        <!-- <div class="form-inline" style="width: 100%">
          </div>
           -->
        <div class="row" style="margin-left:1px ">
          <!-- <div style="flex-grow: 3; width:300px;"></div> -->
          <b-form-input class="mr-2 " style="flex-grow: 3; width:300px;" v-model="search" placeholder="Search by Name"
            @keydown.enter.prevent="queryItem" />
          <!-- <b-form-group style=" width:50%;" label-for="tags-component-select">
  
            <b-form-tags id="tags-component-select" v-model="value" size="md" class="mb-2" add-on-change no-outer-focus>
              <template v-slot="{ disabled }">
                <ul v-if="listKind.length > 0" class="list-inline d-inline-block mb-2">
                  <li v-for="tag in unAvailableOptions" :key="tag.id" class="list-inline-item">

                    <b-form-tag v-if="tag.status == 0" @remove="removeTag(listKind, tag.id)" :title="tag.name"
                      :style="{ backgroundColor: tag.color }" :disabled="disabled" > <b>{{ tag.name
                      }}</b></b-form-tag>
                  </li>
                </ul>
                <b-form-select @change="changeSelection(listKind, selectKind)" v-model="selectKind"
                  :disabled="disabled || availableOptions.length === 0" :options="availableOptions" value-field="id"
                  text-field="name">
                  <template #first>
                
                    <option disabled value="">Choose Specialization...</option>
                  </template>
                </b-form-select>
              </template>
            </b-form-tags>
          </b-form-group> -->
          <button class="btn btn-warning mb-2 mr-1 ml-2 " style="float:right; height: 37px; width: 90px;"
            @click.prevent="openAdvanced">
            <b-row> <i class="fas fa-filter mt-1 mr-2 ml-3"> </i>
              <p>Filter</p>
            </b-row>
          </button>
          <button class="btn btn-secondary mb-2 mr-3 ml-2 " style="float:right; height: 37px; width: 93px;"
            @click.prevent="queryItem">
            <b-row> <i class="fas fa-search mt-1 mr-2 ml-3"> </i>
              <p>Search</p>
            </b-row>
          </button>
        </div>
        <!-- <div class="row" style="margin-left:1px; height: 45px;">
          <p class="mt-2 mr-2">Rate: </p>
          <b-form-group class="mb-2 mr-2">
            <b-form-select v-model="filter" :options="optionsRate" @change="onChangeRate"></b-form-select>
          </b-form-group>

          <p v-if="rateVisitable" class="ml-2 mt-2 mr-2">From</p>
          <b-form-group v-if="rateVisitable" class=" mr-2">
            <b-form-input v-model="rateFrom" style="width: 100px;" id="textarea-auto-height" type="number">
            </b-form-input>
          </b-form-group>
          <p v-if="rateVisitable" class="mt-2 mr-2">To</p>
          <b-form-group v-if="rateVisitable" class="mr-2">
            <b-form-input v-model="rateTo" style="width: 100px;" id="textarea-auto-height" type="number">
            </b-form-input>
          </b-form-group>
     
      
        
        </div> -->

        <!-- style="overflow-x: scroll; width: 100%"      -->

        <b-table id="my-table" bordered head-variant="dark" hover responsive striped small table-variant="light"
          :fields="fieldsPitch" :items="items" thead-class="text-center" no-local-sorting="true"
          @sort-changed="sortChange">

          <template v-slot:cell(a3)="data">
            <div class="float-left ml-1" v-for="card in data.item.kinds" v-bind:key="card.id">
              <b-badge :style="{ backgroundColor: card.color }">{{ card.name }}</b-badge>
            </div>
          </template>
          <template v-slot:cell(a2)="data">
            <div class="text-center">
              <b-link v-if="data.item.website.length > 0" class="text-primary mr-2" @click="onClickWebsite(data.item)">
                <i class="fas fa-globe"></i>
              </b-link>
            </div>
          </template>
          <template v-slot:cell(a7)="data">
            <div class="text-center">
              <b-link v-if="data.item.otherContact.length > 0" class="text-primary mr-2" @click="onClickOther(data.item)">
                <i class="fas fa-address-book"></i>
              </b-link>
            </div>
          </template>
          <template v-slot:cell(notes)="data">
            <div class="text-center">
              <b-link v-if="data.item.notes != null && data.item.notes != ''" class="text-primary mr-2"
                @click="onClickBio(data.item)">
                <i class="fas fa-info-circle"></i>
              </b-link>
            </div>
          </template>
          <template v-slot:cell(gradeRate)="data">
            <div class="text-center">
              <div class="float-left ml-1" v-for="card in findOverlap(data.item.rateFrom, data.item.rateTo)"
                v-bind:key="card.id">
                <b-badge :style="{ backgroundColor: card.color }">{{ convertNameRate(card.name) }}</b-badge>
              </div>
              <!-- <p>{{ findOverlap(data.item.rateFrom,data.item.rateTo)}}</p> -->
            </div>
          </template>
          <template v-slot:cell(rateTo)="data">
            <div class="text-center">
              <p>{{ rateTemplate(data.item.rateFrom, data.item.rateTo) }}</p>
            </div>
          </template>
          <template v-slot:cell(a6)="data">
            <div class="text-center">
              <b-link v-if="data.item.agentName !== null && data.item.agentName !== ''" class="text-primary mr-2"
                @click="onClickAgent(data.item)">
                <i class="fas fa-user-friends"></i>
              </b-link>
            </div>
          </template>
          <template v-slot:cell(pitching)="data">
            <div class="text-center">
              <b-link v-if="data.item.pitching.includes('W')" class="text-primary mr-2" @click="data.toggleDetails">
                {{ data.item.pitching }}
              </b-link>
              <p v-else>{{ data.item.pitching }}</p>
            </div>
          </template>
          <template v-slot:cell(action)="data">
            <div>

              <div class="float-right">
                <!-- <b-link class="text-success mr-2" href="#" @click="data.toggleDetails">
                  <i class="fas fa-chevron-down" v-b-popover.hover.top="'Job'"></i>
                </b-link> -->
                <b-link v-if="director_edit" class="text-primary mr-2" href="#" @click="updateItem(data.item)">
                  <i class="fas fa-pencil-alt" v-b-popover.hover.top="'edit'"></i>
                </b-link>

                <b-link v-if="director_delete" class="text-danger" href="#" @click.prevent="deleteItem(data)">
                  <i class="fas fa-trash" v-b-popover.hover.top="'delete'"></i>
                </b-link>
              </div>
            </div>
          </template>
          <template #row-details="row">
            <b-card>
              <div style="float: right;">
                <button class="btn btn-secondary mb-2 mr-1 ml-2 " style="float:right; height: 37px; width: 40px;"
                  @click.prevent="row.toggleDetails">
                  <b-row> <i class="fas fa-times mt-1 mr-2 ml-3"> </i>
                    <!-- <p>Close</p> -->
                  </b-row>
                </button>
              </div>
              <b-table head-variant="dark !important" :fields="fieldJobView" striped hover :items="row.item.job">
                <template v-slot:cell(status)="data">
                  <div class="text-center ml-1">

                    <!-- <b-badge v-if="data.item.statusID == '1'" variant="success">Đang Thực Hiện</b-badge> -->
                    <b-badge v-if="data.item.status == 'Won'" variant="success">Won</b-badge>
                    <b-badge v-else variant="danger">{{ data.item.status }}</b-badge>

                  </div>
                </template>
              </b-table>
            </b-card>
          </template>
        </b-table>
      </div>
    </div>
    <b-modal content-class="border-0 p-0" v-model="createModalShow" size="lg" :no-close-on-backdrop="true"
      :no-close-on-esc="true" header-bg-variant="info" header-text-variant="light" hide-footer scrollable>

      <template v-slot:modal-title>

        <div v-if="pitching.id <= 0">Add Director</div>
        <div v-else>Update Director</div>
      </template>
      <b-form autocomplete="off" @submit.prevent="submitCreate">
        <b-row>
          <div
            style="background-color: #5384d1; width: 100%; text-align: center; margin-left: 10px;margin-right: 10px; color: white;">
            <b>SUMMARY</b>
          </div>
        </b-row>
        <b-row v-if="name">
          <b-col>
            <b-form-group>
              <template v-slot:label>Name <code>*</code> </template>
              <b-form-input required v-model="pitching.name" id="textarea-auto-height"
                placeholder="Please write down the Name">
              </b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="gender">
          <b-col>
            <b-form-group>
              <template v-slot:label> Gender <code> * </code>
                <input class="mr-1" type="radio" id="one" value="true" v-model="pitching.gender" />
                <label class="mr-3" for="one">Male</label>

                <input class="mr-1" type="radio" id="two" value="false" v-model="pitching.gender" />
                <label for="two">Female</label> </template>


            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="nationalityview">
          <b-col>
            <b-form-group>
              <template v-slot:label>Nationality <code>*</code> </template>
              <b-form-input list="my-list-id" v-model="pitching.nationality"
                placeholder="Please write down the nationality" required></b-form-input>
              <datalist id="my-list-id">
                <option v-for="size in options2" v-bind:key="size">{{ size }}</option>
              </datalist>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="a2">
          <b-col>
            <b-form-group>
              <template v-slot:label> Website </template>
              <template>
                <b-row>
                  <b-col>
                    <!-- <b-form-input size="md" list="my-list-id" v-model="pitch.BudgetRange" placeholder="Please write the budget range (as per your knowledge)" number="true" required></b-form-input> -->
                    <b-form-input v-model="pitching.website" id="textarea-auto-height"
                      placeholder="Please write down the Website">
                    </b-form-input>
                  </b-col>
                  <button class="btn btn-info mr-3" @click.prevent="addNewWebsite">
                    <i class="fas fa-plus"></i> Add Website
                  </button>
                </b-row>
              </template>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="a2">
          <b-col>
            <b-table head-variant="light" :fields="fieldWebsite" bordered hover responsive striped small
              table-variant="light" :items="pitching.listWebsite">
              <template v-slot:cell(url)="data">
                <div class="truncate-text">
                  {{ truncateDescription(data.item.url) }}
                </div>
              </template>
              <template v-slot:cell(action)="data">
                <div>
                  <div class="float-right">
                    <b-link class="text-danger" href="#" @click.prevent="deleteWebsite(data)">
                      <i class="fas fa-trash"></i>
                    </b-link>
                  </div>
                </div>
              </template>
            </b-table>
          </b-col>
        </b-row>
        <b-form-group v-if="a3" label-for="tags-component-select">
          <template v-slot:label>Specialization <code>*</code> </template>
          <!-- Prop `add-on-change` is needed to enable adding tags vie the `change` event -->
          <b-form-tags id="tags-component-select" v-model="value" size="md" class="mb-2" add-on-change no-outer-focus>
            <template v-slot="{ disabled }">
              <ul v-if="originKind.length > 0" class="list-inline d-inline-block mb-2">
                <li v-for="tag in unAvailableOptions2" :key="tag.id" class="list-inline-item">
                  <b-form-tag v-if="tag.status == 0" @remove="removeTagMy(originKind, tag.id)" :title="tag.name"
                    :style="{ backgroundColor: tag.color }" :disabled="disabled"> <b>{{ tag.name
                    }}</b></b-form-tag>
                </li>
              </ul>
              <b-form-select @change="changeSelection(originKind, selectKind)" v-model="selectKind" value-field="id"
                text-field="name" :disabled="disabled || availableOptions2.length === 0" :options="availableOptions2">
                <template #first>
                  <!-- This is required to prevent bugs with Safari -->
                  <option disabled value="">Choose Specialization...</option>
                </template>
              </b-form-select>
            </template>
          </b-form-tags>
        </b-form-group>

        <b-row v-if="level">
          <b-col>
            <b-form-group>
              <template v-slot:label>Quality </template>
              <b-row>
                <b-col>
                  <b-form-select v-model="pitching.level" class=" pt-0 pb-0" size="md" :options="optionsLevel"
                    oninvalid="this.setCustomValidity('Please enter Status')" oninput="setCustomValidity('')" required />
                </b-col>
              </b-row>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>

          <div
            style="background-color: #5384d1; width: 100%; text-align: center; margin-left: 10px;margin-right: 10px; color: white;">
            <b>RATE & BACKGROUND</b>
          </div>
        </b-row>
        <b-row v-if="rateToview">
          <b-col>
            <b-form-group>
              <template v-slot:label> Rate From - To </template>
              <template>
                <b-row>
                  <b-col>
                    <!-- <b-form-input size="md" list="my-list-id" v-model="pitch.BudgetRange" placeholder="Please write the budget range (as per your knowledge)" number="true" required></b-form-input> -->
                    <b-form-input v-model="pitching.rateFrom" id="textarea-auto-height"
                      placeholder="Please write down the From" type="number">
                    </b-form-input>
                  </b-col>
                  <b-col>
                    <!-- <b-form-input size="md" list="my-list-id" v-model="pitch.BudgetRange" placeholder="Please write the budget range (as per your knowledge)" number="true" required></b-form-input> -->
                    <b-form-input v-model="pitching.rateTo" :disabled="checkMaxRateToAddModel" id="textarea-auto-height"
                      placeholder="Please write down the To">
                    </b-form-input>
                    <b-form-group label-for="tags-component-select">
                      <b-form-checkbox v-model="checkMaxRateToAddModel" @change="checkMaxRateToAddFunc()"
                        name="check-button" switch>
                        Max value
                      </b-form-checkbox>
                    </b-form-group>
                  </b-col>
                  <p class="mt-2 mr-3">K USD</p>
                </b-row>
              </template>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row v-if="pitchingview">
          <b-col>
            <b-form-group>
              <template v-slot:label> Background <code> * </code>
                <input class="mr-1" type="radio" id="one" value="true" @change="onChangePitching"
                  v-model="pitching.pitching" />
                <label class="mr-3" for="one">Yes</label>

                <input class="mr-1" type="radio" id="two" value="false" @change="onChangePitching"
                  v-model="pitching.pitching" />
                <label for="two">No</label> </template>


            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="readonly">
          <b-col>
            <b-form-group>
              <template v-slot:label> Job </template>
              <template>
                <b-row>
                  <b-col cols="7">
                    <!-- <b-form-input size="md" list="my-list-id" v-model="pitch.BudgetRange" placeholder="Please write the budget range (as per your knowledge)" number="true" required></b-form-input> -->
                    <b-form-input v-model="pitching.brand" id="textarea-auto-height" placeholder="Brand">
                    </b-form-input>
                  </b-col>
                  <b-col>
                    <!-- <b-form-input size="md" list="my-list-id" v-model="pitch.BudgetRange" placeholder="Please write the budget range (as per your knowledge)" number="true" required></b-form-input> -->
                    <b-form-select v-model="pitching.status" class="mb-3">
                      <b-form-select-option value="Won">Won</b-form-select-option>
                      <b-form-select-option value="Lost">Lost</b-form-select-option>
                    </b-form-select>
                  </b-col>
                  <b-col>
                    <button class="btn btn-info float-right w-100" @click.prevent="addNewJob">
                      <i class="fas fa-plus"></i> Add Job
                    </button>
                  </b-col>

                </b-row>
              </template>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="readonly">
          <b-col>
            <b-table head-variant="light" :fields="fieldJob" bordered hover responsive striped small table-variant="light"
              :items="pitching.listJob">

              <template v-slot:cell(action)="data">
                <div>
                  <div class="float-right">
                    <b-link class="text-danger" href="#" @click.prevent="deleteJob(data)">
                      <i class="fas fa-trash"></i>
                    </b-link>
                  </div>
                </div>
              </template>
            </b-table>
          </b-col>
        </b-row>
        <b-row v-if="score">
          <b-col>
            <b-form-group>
              <template v-slot:label>Score </template>
              <b-row>
                <b-col>
                  <b-form-select v-model="pitching.score" class=" pt-0 pb-0" size="md" :options="optionsScore"
                    oninvalid="this.setCustomValidity('Please enter Score')" oninput="setCustomValidity('abcccccc')"
                    required />
                </b-col>
              </b-row>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <div
            style="background-color: #5384d1; width: 100%; text-align: center; margin-left: 10px;margin-right: 10px; color: white;">
            <b>CONTACT DETAILS</b>
          </div>
        </b-row>
        <b-row v-if="email">
          <b-col>
            <b-form-group>
              <template v-slot:label>Email </template>
              <b-form-input v-model="pitching.email" id="textarea-auto-height" placeholder="Please write down the Email">
              </b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="phone">
          <b-col>
            <b-form-group>
              <template v-slot:label>Phone </template>
              <b-form-input v-model="pitching.phone" id="textarea-auto-height" placeholder="Please write down the Phone ">
              </b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="a7">
          <b-col>
            <b-form-group>
              <template v-slot:label>Director Other Contact </template>
              <template>
                <b-row>
                  <b-col>
                    <!-- listDirectorContact <b-form-input size="md" list="my-list-id" v-model="pitch.BudgetRange" placeholder="Please write the budget range (as per your knowledge)" number="true" required></b-form-input> -->
                    <b-form-input v-model="pitching.directorContact" id="textarea-auto-height"
                      placeholder="Please write down the Director Other Contact ">
                    </b-form-input>
                  </b-col>
                  <button class="btn btn-info mr-3" @click.prevent="addNewDirectorContact">
                    <i class="fas fa-plus"></i> Add Contact
                  </button>
                </b-row>
              </template>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="a7">
          <b-col>
            <b-table head-variant="light" :fields="fieldAgent" bordered hover responsive striped small
              table-variant="light" :items="pitching.listDirectorContact">
              <template v-slot:cell(contact)="data">
                <div class="truncate-text">
                  {{ truncateDescription(data.item.contact) }}
                </div>
              </template>
              <template v-slot:cell(action)="data">
                <div>
                  <div class="float-right">
                    <b-link class="text-danger" href="#" @click.prevent="deleteDirectorContact(data)">
                      <i class="fas fa-trash"></i>
                    </b-link>
                  </div>
                </div>
              </template>
            </b-table>
          </b-col>
        </b-row>


        <b-row v-if="a6">
          <b-col>
            <b-form-group>
              <template v-slot:label>Agent Name </template>
              <b-form-input v-model="pitching.agentName" id="textarea-auto-height"
                placeholder="Please write down the Agent name">
              </b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="a6">
          <b-col>
            <b-form-group>
              <template v-slot:label>Agent Email </template>
              <b-form-input v-model="pitching.agentEmail" id="textarea-auto-height"
                placeholder="Please write down the Agent Email">
              </b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="a6">
          <b-col>
            <b-form-group>
              <template v-slot:label>Agent Phone </template>
              <b-form-input v-model="pitching.agentPhone" id="textarea-auto-height"
                placeholder="Please write down the Agent Phone">
              </b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="a6">
          <b-col>
            <b-form-group>
              <template v-slot:label>Agent Other Contact </template>
              <template>
                <b-row>
                  <b-col>
                    <!-- <b-form-input size="md" list="my-list-id" v-model="pitch.BudgetRange" placeholder="Please write the budget range (as per your knowledge)" number="true" required></b-form-input> -->
                    <b-form-input v-model="pitching.agentContact" id="textarea-auto-height"
                      placeholder="Please write down the Agent Other Contact">
                    </b-form-input>
                  </b-col>
                  <button class="btn btn-info mr-3" @click.prevent="addNewContact">
                    <i class="fas fa-plus"></i> Add Contact
                  </button>
                </b-row>
              </template>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="a6">
          <b-col>
            <b-table head-variant="light" :fields="fieldAgent" bordered hover responsive striped small
              table-variant="light" :items="pitching.listContact">
              <template v-slot:cell(contact)="data">
                <div class="truncate-text">
                  {{ truncateDescription(data.item.contact) }}
                </div>
              </template>
              <template v-slot:cell(action)="data">
                <div>
                  <div class="float-right">
                    <b-link class="text-danger" href="#" @click.prevent="deleteContact(data)">
                      <i class="fas fa-trash"></i>
                    </b-link>
                  </div>
                </div>
              </template>
            </b-table>
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <b-form-group>
              <template v-slot:label>Bio
              </template>
              <b-form-textarea v-model="pitching.notes" id="textarea-auto-height" rows="2" max-rows="15">
              </b-form-textarea>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="float-right">
          <button class="btn-sm border-0 btn-info mr-3 float-right mb-2" @click.prevent="submitCreate"
            :disabled="isDisabled">
            <i class="fas fa-save mr-2 "></i> Save
          </button>
          <button class="btn-sm border-0 btn-secondary  mb-2 mr-2" @click.prevent="closeCreateModal">
            <i class="fas fa-times mr-2 "></i> Close
          </button>

        </b-row>
      </b-form>

    </b-modal>

    <!-- Modal edit  -->

    <b-modal content-class="border-0 p-0" v-model="infoModal" size="lg" :no-close-on-backdrop="true"
      :no-close-on-esc="true" header-bg-variant="info" header-text-variant="light" hide-footer scrollable>
      <template v-slot:modal-title>
        {{ titleInformation }}
      </template>
      <b-row v-if="this.pitching.agentName != null">
        <b-col cols="1">
          <b>Name: </b>
        </b-col>
        <b-col>
          <p>{{ this.pitching.agentName }}</p>
        </b-col>
      </b-row>
      <b-row v-if="this.pitching.agentPhone != null">
        <b-col cols="1">
          <b>Phone: </b>
        </b-col>
        <b-col>
          <p>{{ this.pitching.agentPhone }}</p>
        </b-col>
      </b-row>
      <b-row v-if="this.pitching.agentEmail != null">
        <b-col cols="1">
          <b>Email: </b>
        </b-col>
        <b-col>
          <p>{{ this.pitching.agentEmail }}</p>
        </b-col>
      </b-row>
      <b-row v-if="this.pitching.notes != null">

        <b-col>
          <p>{{ this.pitching.notes }}</p>
        </b-col>
      </b-row>
      <b-table v-if="listGuideline != null" head-variant="light" :fields="infoFieldModal" striped hover
        :items="listGuideline">
        <template #cell()="data">
          <b-link v-if="data.value.includes('http')" class="text-primary mr-2" target="_blank" :href="data.value">{{
            truncateDescription(data.value) }}</b-link>
          <p v-else>{{ data.value }}</p>
        </template>
      </b-table>
    </b-modal>
    <!-- Modal advanced  -->

    <b-modal content-class="border-0 p-0" v-model="advancedModal" size="lg" :no-close-on-backdrop="true"
      :no-close-on-esc="true" header-bg-variant="info" header-text-variant="light" hide-footer scrollable>
      <template v-slot:modal-title>
        Advanced Filter
      </template>

      <b-row>
        <b-col>
          <b-form-group>
            <template v-slot:label>Name </template>
            <b-form-input v-model="search" id="textarea-auto-height" placeholder="Search by Name">
            </b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-form-group v-if="gender" label-for="tags-component-select">
        <template v-slot:label>Gender </template>
        <b-form-tags id="tags-component-select" v-model="searchGender" size="md" class="mb-2" add-on-change
          no-outer-focus>
          <template v-slot="{ tags, inputAttrs, inputHandlers, disabled, removeTag }">
            <ul v-if="tags.length > 0" class="list-inline d-inline-block mb-2">
              <li v-for="tag in tags" :key="tag" class="list-inline-item">
                <b-form-tag @remove="removeTag(tag)" :title="tag" :disabled="disabled"
                  style="background-color: #5384d1">{{ tag }}</b-form-tag>
              </li>
            </ul>
            <b-form-select v-bind="inputAttrs" v-on="inputHandlers" :disabled="disabled || availableGender.length === 0"
              :options="availableGender">
              <template #first>
                <!-- This is required to prevent bugs with Safari -->
                <option disabled value="">Choose a tag...</option>
              </template>
            </b-form-select>
          </template>
        </b-form-tags>
      </b-form-group>
      <b-form-group v-if="nationality" label="Nationality" label-for="tags-with-dropdown">
        <b-form-tags id="tags-with-dropdown" v-model="valueNationality" no-outer-focus class="mb-2">
          <template v-slot="{ tags, disabled, addTag, removeTag }">
            <ul v-if="tags.length > 0" class="list-inline d-inline-block mb-2">
              <li v-for="tag in tags" :key="tag" class="list-inline-item">
                <b-form-tag @remove="removeTag(tag)" :title="tag" :disabled="disabled"
                  style="background-color: #5384d1">{{ tag }}</b-form-tag>
              </li>
            </ul>

            <b-dropdown size="sm" variant="outline-secondary" block menu-class="w-100">

              <template #button-content>
                <b-icon icon="tag-fill"></b-icon> Choose tags
              </template>
              <b-dropdown-form @submit.stop.prevent="() => { }">
                <b-form-group label="Search tags" label-for="tag-search-input" label-cols-md="auto" class="mb-0"
                  label-size="sm" :description="searchDesc" :disabled="disabled">
                  <b-form-input v-model="searchnationality" id="tag-search-input" type="search" size="sm"
                    autocomplete="off"></b-form-input>
                </b-form-group>
              </b-dropdown-form>
              <div class="dropdown-scrollable-container">
                <div class="scrollable" style="max-height: 300px; overflow-y: auto;">
                  <b-dropdown-divider></b-dropdown-divider>
                  <b-dropdown-item-button v-for="option in availableOptionsNationlity" :key="option"
                    @click="onOptionClick({ option, addTag })">
                    {{ option }}
                  </b-dropdown-item-button>
                  <b-dropdown-text v-if="availableOptionsNationlity.length === 0">
                    There are no tags available to select
                  </b-dropdown-text>
                </div>
              </div>
            </b-dropdown>
          </template>
        </b-form-tags>


      </b-form-group>
      <b-form-group v-if="a3" label-for="tags-component-select">
        <template v-slot:label>Specialization </template>
        <b-form-tags id="tags-component-select" v-model="value" size="md" class="mb-2" add-on-change no-outer-focus>
          <template v-slot="{ disabled }">
            <ul v-if="listKind.length > 0" class="list-inline d-inline-block mb-2">
              <li v-for="tag in unAvailableOptions" :key="tag.id" class="list-inline-item">

                <b-form-tag v-if="tag.status == 0" @remove="removeTagMy(listKind, tag.id)" :title="tag.name"
                  :style="{ backgroundColor: tag.color }" :disabled="disabled"> <b>{{ tag.name
                  }}</b></b-form-tag>
              </li>
            </ul>
            <b-form-select @change="changeSelection(listKind, selectKind)" v-model="selectKind"
              :disabled="disabled || availableOptions.length === 0" :options="availableOptions" value-field="id"
              text-field="name">
              <template #first>

                <option disabled value="">Choose Specialization...</option>
              </template>
            </b-form-select>
          </template>
        </b-form-tags>
      </b-form-group>
      <b-form-group v-if="level" label-for="tags-component-select">
        <template v-slot:label>Quality </template>
        <b-form-tags id="tags-component-select" v-model="searchQuality" size="md" class="mb-2" add-on-change
          no-outer-focus>
          <template v-slot="{ tags, inputAttrs, inputHandlers, disabled, removeTag }">
            <ul v-if="tags.length > 0" class="list-inline d-inline-block mb-2">
              <li v-for="tag in tags" :key="tag" class="list-inline-item">
                <b-form-tag @remove="removeTag(tag)" :title="tag" :disabled="disabled"
                  style="background-color: #5384d1">{{ tag }}</b-form-tag>
              </li>
            </ul>
            <b-form-select v-bind="inputAttrs" v-on="inputHandlers" :disabled="disabled || availableQuality.length === 0"
              :options="availableQuality">
              <template #first>
                <!-- This is required to prevent bugs with Safari -->
                <option disabled value="">Choose a tag...</option>
              </template>
            </b-form-select>
          </template>
        </b-form-tags>
      </b-form-group>

      <b-form-group v-if="gradeRate" label-for="tags-component-select">
        <template v-slot:label>Grade rate </template>
        <b-form-tags id="tags-component-select" v-model="valueGradeRate" size="md" class="mb-2" add-on-change
          no-outer-focus>
          <template v-slot="{ disabled }">
            <ul v-if="listRateCard.length > 0" class="list-inline d-inline-block mb-2">
              <li v-for="tag in unAvailableOptionsRate" :key="tag.id" class="list-inline-item">

                <b-form-tag v-if="tag.status == 0" @remove="removeTagRate(listRateCard, tag.id)" :title="tag.name"
                  :style="{ backgroundColor: tag.color }" :disabled="disabled"> <b>{{ tag.name
                  }}</b></b-form-tag>
              </li>
            </ul>
            <b-form-select @change="changeSelection(listRateCard, selectsGradeRate)" v-model="selectsGradeRate"
              :disabled="checkRateManual || availableOptionsRate.length === 0" :options="availableOptionsRate"
              value-field="id" text-field="name">
              <template #first>

                <option disabled value="">Choose Grade rate...</option>
              </template>
            </b-form-select>
          </template>
        </b-form-tags>
      </b-form-group>
      <b-form-group v-if="gradeRate && rateToview" label-for="tags-component-select">
        <b-form-checkbox v-model="checkRateManual" name="check-button" switch>
          Manual Rate
        </b-form-checkbox>
      </b-form-group>
      <b-row v-if="(checkRateManual || !gradeRate) && rateToview">
        <b-col>
          <b-form-group>
            <template v-slot:label> Rate From - To </template>
            <template>
              <b-row>
                <b-col>
                  <!-- <b-form-input size="md" list="my-list-id" v-model="pitch.BudgetRange" placeholder="Please write the budget range (as per your knowledge)" number="true" required></b-form-input> -->
                  <b-form-input v-model="rateFrom" id="textarea-auto-height" placeholder="Please write down the From"
                    type="number">
                  </b-form-input>
                </b-col>
                <b-col>
                  <!-- <b-form-input size="md" list="my-list-id" v-model="pitch.BudgetRange" placeholder="Please write the budget range (as per your knowledge)" number="true" required></b-form-input> -->
                  <b-form-input v-model="rateTo" id="textarea-auto-height" :disabled="checkMaxRateTo"
                    placeholder="Please write down the To">
                  </b-form-input>
                  <b-form-group label-for="tags-component-select">
                    <b-form-checkbox v-model="checkMaxRateTo" @change="checkMaxRateToFunc()" name="check-button" switch>
                      Max value
                    </b-form-checkbox>
                  </b-form-group>
                </b-col>
                <p class="mt-2 mr-3">K USD</p>
              </b-row>
            </template>
          </b-form-group>
        </b-col>
      </b-row>

      <b-form-group v-if="pitching" label-for="tags-component-select">
        <template v-slot:label>Background </template>
        <b-form-tags id="tags-component-select" v-model="searchBackground" size="md" class="mb-2" add-on-change
          no-outer-focus>
          <template v-slot="{ tags, inputAttrs, inputHandlers, disabled, removeTag }">
            <ul v-if="tags.length > 0" class="list-inline d-inline-block mb-2">
              <li v-for="tag in tags" :key="tag" class="list-inline-item">
                <b-form-tag @remove="removeTag(tag)" :title="tag" :disabled="disabled"
                  style="background-color: #5384d1">{{ tag }}</b-form-tag>
              </li>
            </ul>
            <b-form-select v-bind="inputAttrs" v-on="inputHandlers"
              :disabled="disabled || availableBackground.length === 0" :options="availableBackground">
              <template #first>
                <!-- This is required to prevent bugs with Safari -->
                <option disabled value="">Choose a tag...</option>
              </template>
            </b-form-select>
          </template>
        </b-form-tags>
      </b-form-group>
      <b-form-group v-if="score" label-for="tags-component-select">
        <template v-slot:label>Score </template>
        <b-form-tags id="tags-component-select" v-model="searchScore" size="md" class="mb-2" add-on-change no-outer-focus>
          <template v-slot="{ tags, inputAttrs, inputHandlers, disabled, removeTag }">
            <ul v-if="tags.length > 0" class="list-inline d-inline-block mb-2">
              <li v-for="tag in tags" :key="tag" class="list-inline-item">
                <b-form-tag @remove="removeTag(tag)" :title="tag" :disabled="disabled"
                  style="background-color: #5384d1">{{ tag }}</b-form-tag>
              </li>
            </ul>
            <b-form-select v-bind="inputAttrs" v-on="inputHandlers" :disabled="disabled || availableScore.length === 0"
              :options="availableScore">
              <template #first>
                <!-- This is required to prevent bugs with Safari -->
                <option disabled value="">Choose a tag...</option>
              </template>
            </b-form-select>
          </template>
        </b-form-tags>
      </b-form-group>
      <b-col>
        <b-row class="float-left">
          <button class="btn-sm border-0 btn-dark  mb-2 mr-2" @click.prevent="closeAdvanced">
            <i class="fas fa-times mr-2 "></i> Close
          </button>
          <button class="btn-sm border-0 btn-warning  mb-2 mr-2" @click.prevent="clearAdvanced">
            <i class="fas fa-times mr-2 "></i> Clear
          </button>
        </b-row>
        <b-row class="float-right">

          <button class="btn-sm border-0 btn-secondary mr-2 mb-2" @click.prevent="queryItem" :disabled="isDisabled">
            <i class="fas fa-search mr-2 "></i> Search
          </button>
        </b-row>
      </b-col>
    </b-modal>
  </div>
</template>
    
<script>
import axios from "axios";
//import Multiselect from "vue-multiselect";infoFieldModal
import "vue-multiselect/dist/vue-multiselect.min.css";
//import MyDatePicker from "../../components/App/DatePickerUS";

export default {
  name: "Assets",
  components: {
    //  MyCurrencyInput,
    //MyDatePicker,
  },
  data() {
    return {
      selectKind: "",
      //options: ['Kid', 'Anime', 'Family', 'Story'],
      options: [{ value: { id: 1, color: 'red' }, text: 'Kid' },
      { value: { id: 2, color: 'green' }, text: 'Family' }],
      options2: ['Afghanistan',
'Aland',
'Albania',
'Algeria',
'American Samoa',
'Andorra',
'Angola',
'Anguilla',
'Antarctica',
'Antigua and Barbuda',
'Argentina',
'Armenia',
'Aruba',
'Ascension',
'Australia',
'Austria',
'Azerbaijan',
'Bahamas, The',
'Bahrain',
'Bangladesh',
'Barbados',
'Belarus',
'Belgium',
'Belize',
'Benin',
'Bermuda',
'Bhutan',
'Bolivia',
'Bosnia and Herzegovina',
'Botswana',
'Bouvet Island',
'Brazil',
'British Indian Ocean Territory',
'British Virgin Islands',
'Brunei',
'Bulgaria',
'Burkina Faso',
'Burundi',
'Cambodia',
'Cameroon',
'Canada',
'Cape Verde',
'Cayman Islands',
'Central African Republic',
'Chad',
'Chile',
'China',
'Christmas Island',
'Cocos (Keeling) Islands',
'Colombia',
'Comoros',
'Congo ? Brazzaville',
'Congo ? Kinshasa',
'Cook Islands',
'Costa Rica',
'Cote d\'Ivoire (Ivory Coast)',
'Croatia',
'Cuba',
'Cyprus',
'Czech Republic',
'Denmark',
'Djibouti',
'Dominica',
'Dominican Republic',
'Ecuador',
'Egypt',
'El Salvador',
'Equatorial Guinea',
'Eritrea',
'Estonia',
'Ethiopia',
'Falkland Islands',
'Faroe Islands',
'Fiji',
'Finland',
'France',
'French Guiana',
'French Polynesia',
'French Southern Territories',
'Gabon',
'Gambia, The',
'Georgia',
'Germany',
'Ghana',
'Gibraltar',
'Greece',
'Greenland',
'Grenada',
'Guam',
'Guatemala',
'Guernsey',
'Guinea',
'Guinea-Bissau',
'Guyana',
'Haiti',
'Heard and McDonald Islands',
'Honduras',
'Hong Kong',
'Hungary',
'Iceland',
'India',
'Indonesia',
'Iran',
'Iraq',
'Ireland',
'Isle of Man',
'Israel',
'Italy',
'Jamaica',
'Japan',
'Jersey',
'Jordan',
'Kazakhstan',
'Kenya',
'Kiribati',
'Kosovo',
'Kuwait',
'Kyrgyzstan',
'Laos',
'Latvia',
'Lebanon',
'Lesotho',
'Liberia',
'Libya',
'Liechtenstein',
'Lithuania',
'Luxembourg',
'Macau',
'Macedonia',
'Madagascar',
'Malawi',
'Malaysia',
'Maldives',
'Mali',
'Malta',
'Marshall Islands',
'Martinique',
'Mauritania',
'Mauritius',
'Mayotte',
'Mexico',
'Micronesia',
'Moldova',
'Monaco',
'Mongolia',
'Montenegro',
'Montserrat',
'Morocco',
'Mozambique',
'Myanmar',
'Namibia',
'Nauru',
'Nepal',
'Netherlands',
'Netherlands Antilles',
'New Caledonia',
'New Zealand',
'Nicaragua',
'Niger',
'Nigeria',
'Niue',
'Norfolk Island',
'North Korea',
'Northern Mariana Islands',
'Norway',
'Oman',
'Pakistan',
'Palau',
'Palestinian Territories',
'Panama',
'Papua New Guinea',
'Paraguay',
'Peru',
'Philippines',
'Pitcairn Islands',
'Poland',
'Portugal',
'Puerto Rico',
'Qatar',
'Reunion',
'Romania',
'Russia',
'Rwanda',
'Saint Helena',
'Saint Kitts and Nevis',
'Saint Lucia',
'Saint Pierre and Miquelon',
'Samoa',
'San Marino',
'Sao Tome and Principe',
'Saudi Arabia',
'Senegal',
'Serbia',
'Seychelles',
'Sierra Leone',
'Singapore',
'Slovakia',
'Slovenia',
'Solomon Islands',
'Somalia',
'South Africa',
'South Georgia Island',
'South Korea',
'Spain',
'Sri Lanka',
'St. Vincent and the Grenadines',
'Sudan',
'Suriname',
'Svalbard',
'Swaziland',
'Sweden',
'Switzerland',
'Syria',
'Taiwan',
'Tajikistan',
'Tanzania',
'Thailand',
'Timor-Leste (East Timor)',
'Togo',
'Tokelau',
'Tonga',
'Trinidad and Tobago',
'Tristan da Cunha',
'Tunisia',
'Turkey',
'Turkmenistan',
'Turks and Caicos Islands',
'Tuvalu',
'U.S. Virgin Islands',
'Uganda',
'Ukraine',
'United Arab Emirates',
'United Kingdom',
'United States',
'Uruguay',
'Uzbekistan',
'Vanuatu',
'Vatican City',
'Venezuela',
'Vietnam',
'Wallis and Futuna',
'Western Sahara',
'Yemen',
'Zambia',
'Zimbabwe',
'Unknown'],
      listKind: [],
      value: [],
      mySortBy: null,
      mySortDesc: null,
      originKind: [],
      listNationality: [],
      rateTo: null,
      rateFrom: null,
      searchQuality: [],
      searchGender: [],
      searchnationality: '',
      searchBackground: [],
      searchScore: [],
      valueNationality: [],
      titleInformation: "",
      listGuideline: [],
      listRateCard: [],
      selectsGradeRate: "",
      valueGradeRate: [],
      optionsRate: [
        { value: 0, text: 'All' },
        { value: 1, text: 'Under 5k' },
        { value: 2, text: '5-10K' },
        { value: 3, text: "10-12K" },
        { value: 4, text: '12-15K' },
        { value: 5, text: '15-20K' },
        { value: 6, text: 'above 20k' },
        { value: 7, text: 'Other' },
      ],
      optionsBackground: ['Yes', 'No'],
      optionsLevel: [
        { value: null, text: 'Please select the Quality' },
        { value: 'High', text: 'High' },
        { value: 'Medium High', text: 'Medium High' },
        { value: 'Medium Low', text: 'Medium Low' },
        { value: 'Low', text: 'Low' },
      ],
      optionsScore: [
        { value: null, text: 'Please select the Score' },
        { value: '1', text: '1' },
        { value: '2', text: '2' },
        { value: '3', text: '3' },
        { value: '4', text: '4' },
        { value: '5', text: '5' },
        { value: 'No', text: 'No' },
      ],
      optionsLevel2: ['High', 'Medium High', 'Medium Low', 'Low'],
      optionsGender: ['Male', 'Female'],
      optionsSocre: ['1', '2', '3', '4', '5', 'No'],
      fieldWebsite: [
        {
          key: "url",
          label: "URL",
          tdClass: "text-left",
          thClass: "align-middle",
          thStyle: { width: "200px", textAlign: "center" },
        },
        {
          key: "action",
          label: "Action",
          tdClass: "text-center",
          thClass: "align-middle",
          // thStyle: {width: "80px !important" , textAlign : "center"},
          thStyle: { width: "20px", textAlign: "center" },
        }
      ],
      fieldAgent: [
        {
          key: "contact",
          label: "Contact",
          tdClass: "text-left",
          thClass: "align-left ",
          thStyle: { width: "200px", textAlign: "center" },
        },
        {
          key: "action",
          label: "Action",
          tdClass: "text-center",
          thClass: "align-middle",
          // thStyle: {width: "80px !important" , textAlign : "center"},
          thStyle: { width: "20px", textAlign: "center" },
        }
      ],
      fieldJob: [
        {
          key: "brand",
          label: "Brand",
          tdClass: "text-left",
          thClass: "align-middle",
          thStyle: { width: "100px", textAlign: "center" },
        },
        {
          key: "status",
          label: "Status",
          tdClass: "text-left",
          thClass: "align-middle",
          thStyle: { width: "100px", textAlign: "center" },
        },
        {
          key: "action",
          label: "Action",
          tdClass: "text-center",
          thClass: "align-middle",
          // thStyle: {width: "80px !important" , textAlign : "center"},
          thStyle: { width: "20px", textAlign: "center" },
        }
      ],
      fieldJobView: [
        {
          key: "brand",
          label: "Brand",
          tdClass: "text-left",
          thClass: "align-middle",
          thStyle: { width: "100px", textAlign: "center" },
        },
        {
          key: "status",
          label: "Status",
          tdClass: "text-left",
          thClass: "align-middle",
          thStyle: { width: "10px", textAlign: "center" },
        }
      ],
      fieldsPitch: [
        {
          key: "name",
          label: "Name",
          sortable: true,
          thClass: "align-middle",
          thStyle: { width: "70px !important", textAlign: "center" },
        },
        {
          key: "gender",
          label: "Gender",
          sortable: true,
          thClass: "align-middle",
          thStyle: { width: "50px !important", textAlign: "center" },
          formatter: 'convertGender',
        },
        {
          key: "nationality",
          label: "Nationality",
          sortable: true,
          thClass: "align-middle",
          thStyle: { width: "70px !important", textAlign: "center" },
        },
        {
          key: "a2",
          label: "Website",
          sortable: false,
          thClass: "align-middle",
          thStyle: { width: "40px !important", textAlign: "center" },
        },
        {
          key: "a3",
          label: "Specialization",
          sortable: false,
          // thClass: "align-middle",
          tdClass: "text-center",
          thClass: "align-middle",
          thStyle: { width: "170px !important", textAlign: "center" },
          sortByFormatted: false,

          //formatter: 'convertDate',
        },
        {
          key: "level",
          label: "Quality",
          sortable: true,
          thClass: "align-middle",
          thStyle: { width: "20px !important", textAlign: "center" },
          //formatter: 'convertEmail'
        },
        {
          key: "gradeRate",
          label: "Grade rate",
          sortable: false,
          thClass: "align-middle",
          thStyle: { width: "70px !important", textAlign: "center" },
          sortByFormatted: false,
        },
        {
          key: "rateTo",
          label: "Rate card (K USD)",
          sortable: true,
          thClass: "align-middle",
          thStyle: { width: "70px !important", textAlign: "center" },
        },
        {
          key: "pitching",
          label: "Background",
          sortable: false,
          tdClass: "text-right",
          thClass: "align-middle",
          thStyle: { width: "70px !important", textAlign: "center" },
        },

        {
          key: "score",
          label: "Score",
          sortable: true,
          thClass: "align-middle",
          thStyle: { width: "20px !important", textAlign: "center" },
          //formatter: 'convertEmail'
        },
        {
          key: "email",
          label: "Email",
          sortable: true,
          thClass: "align-middle",
          thStyle: { width: "20px !important", textAlign: "center" },
          //formatter: 'convertEmail'
        },
        {
          key: "phone",
          label: "Phone",
          sortable: true,
          thClass: "align-middle",
          thStyle: { width: "100px !important", textAlign: "center" },
          //formatter: 'convertAgency',
        },
        {
          key: "a7",
          label: "Other contacts",
          sortable: false,
          thClass: "align-middle",
          thStyle: { width: "50px !important", textAlign: "center" },
        },
        {
          key: "a6",
          label: "Agent",
          sortable: false,
          thClass: "align-middle",
          thStyle: { width: "50px !important", textAlign: "center" },
        },
        {
          key: "notes",
          label: "Bio",
          sortable: false,
          thClass: "align-middle",
          thStyle: { width: "50px !important", textAlign: "center" },
        },
        {
          key: "action",
          label: "",
          tdClass: "text-center",
          thClass: "align-middle",
          // thStyle: {width: "80px !important" , textAlign : "center"},
          thStyle: { width: "50px", textAlign: "center" },
        },
      ],
      agencyQuestion: true,
      decisionMakerQuestion: true,
      pitching: {
        id: 0,
        name: null,
        level: null,
        email: null,
        phone: null,
        agentName: null,
        agentPhone: null,
        agentContact: null,
        agentEmail: null,
        score: null,
        nationality: null,
        pitching: null,
        notes: null,
        rateTo: 0,
        rateFrom: 0,
        updateBy: null,
        listKind: [],
        listWebsite: [],
        listContact: [],
        listJob: [],
        website: "",
        brand: "",
        status: "",
        directorContact: "",
        listDirectorContact: [],
        gender: null,
      },

      createModalShow: false,
      checkMaxRateTo: false,
      checkMaxRateToAddModel: false,
      checkRateManual: false,
      // to: null,
      // from: null,
      filter: 0,
      search: null,
      items: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      // filterOn: ['outcome', 'productionHouse'],
      //filter: null,
      isDisabled: false,
      query: null,


      infoModal: false,
      advancedModal: false,
      //assets: [],




      modalShow: false,

      infoFieldModal: [],


      state: "Normal",
      state2: "Normal",
    };
  },

  computed: {

    gradeRate() {
      return this.$store.getters.hasPermission("gradeRate");
    },
    name() {
      return this.$store.getters.hasPermission("name");
    },
    a2() {
      return this.$store.getters.hasPermission("a2");
    },
    a3() {
      return this.$store.getters.hasPermission("a3");
    },
    level() {
      return this.$store.getters.hasPermission("level");
    },
    email() {
      return this.$store.getters.hasPermission("email");
    },
    phone() {
      return this.$store.getters.hasPermission("phone");
    },
    a7() {
      return this.$store.getters.hasPermission("a7");
    },
    a6() {
      return this.$store.getters.hasPermission("a6");
    },
    nationalityview() {
      return this.$store.getters.hasPermission("nationality");
    },
    pitchingview() {
      return this.$store.getters.hasPermission("pitching");
    },
    gender() {
      return this.$store.getters.hasPermission("gender");
    },
    rateToview() {
      return this.$store.getters.hasPermission("rateTo");
    },
    score() {
      return this.$store.getters.hasPermission("score");
    },
    nationality() {
      return this.$store.getters.hasPermission("nationality");
    },
    unAvailableOptions() {

      return this.listKind.filter(opt => opt.status == 0)
    },
    unAvailableOptionsRate() {

      return this.listRateCard.filter(opt => opt.status == 0)
    },
    availableOptions() {

      return this.listKind.filter(opt => opt.status == 1)
    },
    availableOptionsRate() {

      return this.listRateCard.filter(opt => opt.status == 1)
    },
    unAvailableOptions2() {
      return this.originKind.filter(opt => opt.status == 0)
    },
    availableOptions2() {
      return this.originKind.filter(opt => opt.status == 1)
    },
    availableQuality() {
      return this.optionsLevel2.filter(opt => this.searchQuality.indexOf(opt) === -1)
    },
    availableGender() {
      return this.optionsGender.filter(opt => this.searchGender.indexOf(opt) === -1)
    },
    availableBackground() {
      return this.optionsBackground.filter(opt => this.searchBackground.indexOf(opt) === -1)
    },
    availableScore() {
      return this.optionsSocre.filter(opt => this.searchScore.indexOf(opt) === -1)
    },
    //Permission Buuton Them Taisan/Them LoaiTaiSan/Them khu vuc
    director_add() {
      return this.$store.getters.hasPermission("director_add");
    },
    director_edit() {
      return this.$store.getters.hasPermission("director_edit");
    },
    director_delete() {
      return this.$store.getters.hasPermission("director_delete");
    },
    director_report() {
      return this.$store.getters.hasPermission("director_report");
    },
    rateVisitable() {
      return this.filter === 7;
    },

    readonly() {
      return this.state === 'readonly'
    },
    readonly2() {
      return this.state2 === 'readonly'
    },
    criteria() {
      // Compute the search criteria
      return this.searchnationality.trim().toLowerCase()
    },
    availableOptionsNationlity() {
      const criteria = this.criteria
      // Filter out already selected options
      const options = this.options2.filter(opt => this.valueNationality.indexOf(opt) === -1)
      if (criteria) {
        // Show only options that match criteria
        return options.filter(opt => opt.toLowerCase().indexOf(criteria) > -1);
      }
      // Show all options available
      return options
    },
    searchDesc() {
      if (this.criteria && this.availableOptionsNationlity.length === 0) {
        return 'There are no tags matching your search criteria'
      }
      return ''
    }

  },

  beforeRouteEnter(to, from, next) {
    axios
      .all([
        axios.get("/api/director/getDirectors", { params: to.query }),
        axios.get("/api/kindDirector/getSelect"),
        axios.get(`/api/role/colDirector?PermissionGroupId=5033`),
        axios.get("/api/RateValue/getforDirector"),
      ])
      .then(
        axios.spread(
          (
            directorRecords,
            listKind,
            col,
            rateValue,
          ) => {
            next((vm) =>
              vm.initData(
                directorRecords.data,
                listKind.data,
                col.data,
                rateValue.data
              )
            );
          }
        )
      );
  },
  beforeRouteUpdate(to, from, next) {
    axios
      .get("/api/director/getDirectors", { params: to.query })
      .then((response) => {

        //  this.$log(response);
        this.items = response.data.list;
        this.totalRows = response.data.totalCount;

        //this.$log(this.items);
        // next();
      })
      .catch((err) => {
        next();
      });
  },
  methods: {
    onOptionClick({ option, addTag }) {
      addTag(option)
      this.searchnationality = ''
    },
    test() {
      this.listKind.forEach(element => {
        if (element.id == this.selectKind) {
          element.status = 0;
        }
      });
      // this.$log(this.listKind);
    },
    changeSelection(list, value) {
      list.forEach(element => {
        if (element.id == value) {
          element.status = 0;
        }
      });
      // this.$log(this.listKind);
    },
    removeTagMy(list, id) {
      this.selectKind = '';
      list.forEach(element => {
        if (element.id == id) {
          element.status = 1;
        }
      });
    },
    removeTagRate(list, id) {
      this.selectsGradeRate = '';
      list.forEach(element => {
        if (element.id == id) {
          element.status = 1;
        }
      });
    },
    submitCreate() {
      this.isDisabled = true;
      if (this.originKind.filter(opt => opt.status == 0).length == 0) {
        this.$toast.error("Choosing specialization of director pls!", "Error", {
          timeout: 3000,
        });
        return (this.isDisabled = false);
      }
      var tmpTo;

      if (this.pitching.rateTo == null || this.pitching.rateTo == '') tmpTo = -1;
      else tmpTo = this.pitching.rateTo == 'Max' ? 1000 : Number(this.pitching.rateTo);

      var tmpFrom;
      if (this.pitching.rateFrom == null || this.pitching.rateFrom == '') tmpFrom = -1;
      else tmpFrom = Number(this.pitching.rateFrom);
      const formSubmit = {
        id: this.pitching.id,
        name: this.pitching.name,
        level: this.pitching.level,
        email: this.pitching.email,
        agentName: this.pitching.agentName,
        agentEmail: this.pitching.agentEmail,
        nationality: this.pitching.nationality,
        pitching: this.pitching.pitching,
        notes: this.pitching.notes,
        gender: this.pitching.gender,
        rateTo: tmpTo,
        rateFrom: tmpFrom,
        updateBy: this.$store.state.auth.accountId,
        phone: this.pitching.phone,
        agentPhone: this.pitching.agentPhone,
        score: this.pitching.score,
        listKind: this.originKind.filter(opt => opt.status === 0)
          .map(x => ({ id: x.id, name: x.name, color: x.color })),
        listJob: this.pitching.listJob,
        listWebsite: this.pitching.listWebsite.map(x => x.url),
        listContact: this.pitching.listContact.map(x => x.contact),
        ListDirectorContact: this.pitching.listDirectorContact.map(x => x.contact)
      };
      axios.post("/api/director/storeDirector", formSubmit)
        .then((res) => {
          this.isDisabled = false;

          // formSubmit.date = res.data.date;
          // this.$log(formSubmit.date);
          // formSubmit.id = res.data.id;
          // formSubmit.createdBy = res.data.createdBy;
          // const pitch_created = this.$copy(formSubmit);

          if (this.pitching.id <= 0) {
            this.items.unshift(res.data);
            this.$toast.success("Create director record successfully !", "Successful", {
              timeout: 3000,
            });
          } else {
            this.items.splice(this.currentIndex, 1, res.data);
            this.$toast.success("Update director record successfully !", "Successful", {
              timeout: 3000,
            });
          }

          this.createModalShow = false;

        }
        ).catch((err) => {
          this.isDisabled = false;
          this.$toast.error(err.response.data, "Error", {
            timeout: 3000,
          });
        })
    },
    addNewWebsite() {
      if (this.pitching.website == null || this.pitching.website == '') {
        this.$toast.error("Data cannot be blank", "Error", {
          timeout: 3000,
        });
        return;
      }
      var item = {
        url: this.pitching.website,
      }
      this.pitching.listWebsite.unshift(item);
      this.pitching.website = "";
    },
    convertNameRate(value) {
      const parts = value.split(':');
      const result = parts[0];

      return result;
    },
    addNewContact() {
      if (this.pitching.agentContact == null || this.pitching.agentContact == '') {
        this.$toast.error("Data cannot be blank", "Error", {
          timeout: 3000,
        });
        return;
      }
      var item = {
        contact: this.pitching.agentContact,
      }
      this.pitching.listContact.unshift(item);
      this.pitching.agentContact = "";
    },
    addNewDirectorContact() {
      if (this.pitching.directorContact == null || this.pitching.directorContact == '') {
        this.$toast.error("Data cannot be blank", "Error", {
          timeout: 3000,
        });
        return;
      }
      var item = {
        contact: this.pitching.directorContact,
      }
      this.pitching.listDirectorContact.unshift(item);
      this.pitching.directorContact = "";
    },
    addNewJob() {

      var item = {
        brand: this.pitching.brand,
        status: this.pitching.status,
      }
      this.pitching.listJob.unshift(item);
      this.pitching.brand = "";

    },
    closeCreateModal() {
      this.createModalShow = false;
    },
    onChangePitching() {
      if (this.pitching.pitching == "true" || this.pitching.pitching == true) {
        this.state = "readonly";
        //this.pitch.Agency = "";
      } else {
        this.state = "normal";
      }
    },
    onChangeRate() {
      switch (this.filter) {
        case 0:
          this.rateFrom = 0;
          this.rateTo = 10000;
          break;
        case 1:
          this.rateFrom = 0;
          this.rateTo = 5;
          break;
        case 2:
          this.rateFrom = 5;
          this.rateTo = 10;
          break;
        case 3:
          this.rateFrom = 10;
          this.rateTo = 12;
          break;
        case 4:
          this.rateFrom = 12;
          this.rateTo = 15;
          break;
        case 5:
          this.rateFrom = 15;
          this.rateTo = 20;
          break;
        case 6:
          this.rateFrom = 20;
          this.rateTo = 10000;
          break;
        case 7:
          this.rateFrom = null;
          this.rateTo = null;
          break;
      }
    },
    openAdvanced() {
      this.advancedModal = true;
    },
    closeAdvanced() {
      this.advancedModal = false;
    },
    clearAdvanced() {
      this.search = '';
      this.rateFrom = null;
      this.rateTo = null;
      this.checkRateManual = false;
      this.listKind.forEach(element => {
        element.status = 1;
      });
      this.listRateCard.forEach(element => {
        element.status = 1;
      });
      this.searchQuality = [];
      this.searchBackground = [];
      this.searchGender = [];
      this.searchScore = [];
      this.valueNationality = [];
      //this.advancedModal = false;
      //this.queryItem();
    },
    openInfoModal() {
      this.infoModal = true;
    },
    closeInfoModal() {
      this.infoModal = true;
    },
    createPitchModal() {
      this.pitching.id = 0;
      this.pitching.name = null;
      this.pitching.level = null;
      this.pitching.email = null;
      this.pitching.phone = null;
      this.pitching.agentName = null;
      this.pitching.agentContact = null;
      this.pitching.agentEmail = null;
      this.pitching.score = null;
      this.pitching.nationality = null;
      this.pitching.pitching = "false";
      this.pitching.gender = "true";
      this.onChangePitching();
      this.pitching.notes = null;
      this.pitching.rateTo = 0;
      this.pitching.rateFrom = 0;
      this.checkMaxRateToAddModel = false;
      this.pitching.listWebsite = [];
      this.pitching.status = 'Won';
      this.selectKind = '';
      this.originKind.forEach(element => {
        element.status = 1;
      });
      this.createModalShow = true;
      this.pitching.listContact = [];
      this.pitching.listJob = [];
      this.pitching.website = "";
      this.pitching.brand = "";
      this.pitching.directorContact = "";
      this.pitching.listDirectorContact = [];
    },
    initData(
      directorRecords,
      listKind,
      col,
      rateValue
    ) {
      this.listRateCard = rateValue;
      this.listRateCard.forEach(element => {
        if(element.from == null && element.to == null){
          element.name = element.name2;
        }
      });
      this.items = directorRecords.list;
      this.currentPage = 1;
      this.totalRows = directorRecords.totalCount;
      this.fieldsPitch = this.fieldsPitch.filter(x => col.includes(x.key));
      this.listKind = this.$copy(listKind);
      this.originKind = JSON.parse(JSON.stringify(listKind));
      this.options2.sort();
    },
    findOverlap(inputFrom, inputTo) {
      // const data = {
      //   F: { from: 0, to: 5 },
      //   E: { from: 5, to: 10 },
      //   D: { from: 10, to: 12 },
      //   C: { from: 12, to: 15 }
      // };gradeRate

      const result = [];
      this.listRateCard.forEach(element => {
        if (inputFrom < element.to && inputTo >= element.from) {
          result.push(element);
        }
        if(inputFrom == null && element.from == null){
          result.push(element);
        }
      });


      return result;
    },
    exportReport() {
      var search = this.search;
      var rateFrom = null;
      var rateTo = null;
      if (!this.checkRateManual) {
        this.listRateCard.forEach(element => {
          if (element.status == 0) {
            if (rateTo == null) {
              rateTo = element.to;
            } else if (rateTo != null && rateTo <= element.to) {
              rateTo = element.to;
            }

            if (rateFrom == null) {
              rateFrom = element.from;
            } else if (rateFrom != null && rateFrom >= element.from) {
              rateFrom = element.from;
            }
          }
        });

      } else {
        rateFrom = this.rateFrom;
        rateTo = this.rateTo;
      }
      var searchGender = '';
      this.searchGender.forEach(element => {
        searchGender += element + "-";
      });
      var searchScore = '';
      this.searchScore.forEach(element => {
        searchScore += element + "-";
      });
      var searchQuality = '';
      this.searchQuality.forEach(element => {
        searchQuality += element + "-";
      });
      var searchBackground = '';
      this.searchBackground.forEach(element => {
        searchBackground += element + "-";
      });
      var searchnationality = '';
      this.valueNationality.forEach(element => {
        searchnationality += element + "-";
      });
      var kind = "";
      this.listKind.filter(opt => opt.status === 0).forEach(element => {
        kind += element.id + "-";
      });
      axios.get(`/api/Director/report`, {
        responseType: 'blob', params: {
          search,
          rateFrom,
          rateTo,
          searchScore,
          searchQuality,
          searchBackground,
          searchnationality,
          kind,
          searchGender
        }
      })
        .then((res) => {
          let filename = res.headers["content-disposition"]
            .split(";")
            .find(function (el) {
              if (el.includes("filename=")) return el;
            })
            .replace("filename=", "")
            .trim();
          const url = window.URL.createObjectURL(
            new Blob([res.data], {
              type: "application/vnd.ms-excel;charset=utf-8",
            })
          );
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", filename); //or any other extension
          document.body.appendChild(link);
          link.click();
        });
    },


    updateItem(data) {
      this.currentIndex = this.items.indexOf(data);
      this.pitching.id = data.id;
      this.pitching.name = data.name;
      this.pitching.level = data.level;
      this.pitching.email = data.email;
      this.pitching.phone = data.phone;
      this.pitching.score = data.score;
      this.pitching.agentName = data.agentName;
      this.pitching.agentContact = data.agentContact;
      this.pitching.agentEmail = data.agentEmail;
      this.pitching.nationality = data.nationality;
      this.pitching.gender = data.gender;
      if (data.pitching == 'No') {
        this.pitching.pitching = "false";
      } else {
        this.pitching.pitching = "true";
      }
      this.onChangePitching();

      this.pitching.notes = data.notes;
      if (data.rateTo == null) this.pitching.rateTo = null;
      else this.pitching.rateTo = data.rateTo == 1000 ? "Max" : Number(data.rateTo);
      if (data.rateTo == 1000) this.checkMaxRateToAddModel = true;
      else this.checkMaxRateToAddModel = false;
      if (data.rateFrom == null) this.pitching.rateFrom = null;
      else this.pitching.rateFrom = Number(data.rateFrom);
      this.pitching.listWebsite = data.website;
      this.pitching.status = 'Won';
      this.selectKind = '';
      this.originKind.forEach(element => {
        element.status = 1;
      });
      this.originKind.forEach(element => {
        data.kinds.forEach(x => {
          if (x.id == element.id) {
            element.status = 0;
          }
        });

      });
      this.createModalShow = true;
      this.pitching.listContact = data.otherAgent;
      this.pitching.listJob = data.job.map(x => ({ brand: x.brand, status: x.status }));
      this.pitching.website = "";
      this.pitching.brand = "";
      this.pitching.directorContact = "";
      this.pitching.listDirectorContact = data.otherContact;
      this.createModalShow = true;
    },
    sortChange(ctx) {
      // this.$log(ctx.sortBy);
      // this.$log(ctx.sortDesc);
      // this.$log("/////////");
      // this.$log(this.mySortBy);
      // this.$log(this.mySortDesc);

      this.mySortBy = ctx.sortBy;
      this.mySortDesc = ctx.sortDesc;

      let query = Object.assign({}, this.$route.query);
      query.pageNumber = this.currentPage;
      query.col = ctx.sortBy;
      query.sort = ctx.sortDesc;
      query.rateFrom = this.rateFrom;
      query.rateFrom = null;
      query.rateTo = null;
      query.searchGender = '';
      this.searchGender.forEach(element => {
        query.searchGender += element + "-";
      });
      if (!this.checkRateManual) {
        this.listRateCard.forEach(element => {
          if (element.status == 0) {
            if(element.to == null && element.from == null){
              query.rateNA = true;
            }
            if (query.rateTo == null) {
              query.rateTo = element.to;
            } else if (query.rateTo != null && query.rateTo <= element.to && element.to != null) {
              query.rateTo = element.to;
            }

            if (query.rateFrom == null) {
              query.rateFrom = element.from;
            } else if (query.rateFrom != null && query.rateFrom >= element.from && element.from != null) {
              query.rateFrom = element.from;
            }
            
          }
        });
      } else {
        query.rateFrom = this.rateFrom;
        if (this.rateTo == 'Max') {
          query.rateTo = 1000;
        } else {
          query.rateTo = this.rateTo;
        }
      }
      query.searchQuality = '';

      query.searchBackground = '';
      query.searchnationality = '';
      query.searchScore = '';
      this.searchScore.forEach(element => {
        query.searchScore += element + "-";
      });

      this.searchQuality.forEach(element => {
        query.searchQuality += element + "-";
      });

      this.searchBackground.forEach(element => {
        query.searchBackground += element + "-";
      });

      this.valueNationality.forEach(element => {
        query.searchnationality += element + "-";
      });
      var kind = "";
      //this.$log(this.listKind);
      this.listKind.filter(opt => opt.status === 0).forEach(element => {
        kind += element.id + "-";
      });
      query.kind = kind;
      this.$router.push({ query: query });
    },
    checkMaxRateToFunc() {
      if (!this.checkMaxRateTo) {
        this.rateTo = 'Max';
      } else {
        this.rateTo = '';
      }
    },
    checkMaxRateToAddFunc() {
      if (!this.checkMaxRateToAddModel) {
        this.pitching.rateTo = 'Max';
      } else {
        this.pitching.rateTo = "";
      }
    },
    deleteItem(data) {
      this.$toast.question("Do you really want to delete this record?", "Warning", {
        timeout: 20000,
        close: false,
        overlay: true,
        displayMode: "once",
        position: "center",
        buttons: [
          [
            "<button><b>Yes</b></button>",
            (instance, toast) => {
              axios
                .delete(`api/director/delete?id=${data.item.id}&bleacher=${this.$store.state.auth.accountId}`)
                .then((res) => {
                  this.items.splice(data.index, 1);
                  this.$toast.success("Delete successfully !", "Successful", {
                    timeout: 3000,
                  });
                })
                .catch((err) => {
                  this.$toast.error(err.response.data, "Error", {
                    timeout: 3000,
                  });
                });
              instance.hide({ transitionOut: "fadeOut" }, toast, "button");
            },
            true,
          ],
          [
            "<button>No</button>",
            function (instance, toast) {
              instance.hide({ transitionOut: "fadeOut" }, toast, "button");
            },
          ],
        ],
      });
    },
    onClickAgent(data) {
      this.titleInformation = "Agent information";
      this.infoFieldModal = JSON.parse(JSON.stringify(this.fieldAgent));
      this.infoFieldModal.pop();
      this.pitching.agentName = data.agentName;
      this.pitching.agentPhone = data.agentPhone;
      this.pitching.agentEmail = data.agentEmail;
      this.listGuideline = data.otherAgent;
      this.pitching.notes = null;
      this.openInfoModal();
    },
    onClickOther(data) {
      this.titleInformation = "Other contact information";
      this.infoFieldModal = JSON.parse(JSON.stringify(this.fieldAgent));
      this.infoFieldModal.pop();
      this.pitching.agentName = null;
      this.pitching.agentPhone = null;
      this.pitching.agentEmail = null;
      this.listGuideline = data.otherContact;
      this.pitching.notes = null;
      this.openInfoModal();
    },
    rateToTemplate(to) {
      if (to > 999) return 'max ';
      return to;
    },
    rateTemplate(from, to) {
      if (from !== null && to !== null && from === to) {
        //this.$log(to + "-" + from);
        return from;
      }
      if (from == null && to == null) return "Other";
      return from + " - " + this.rateToTemplate(to);
    },
    onClickBio(data) {
      this.titleInformation = "Bio";
      this.infoFieldModal = JSON.parse(JSON.stringify(this.fieldAgent));
      this.infoFieldModal.pop();
      this.pitching.agentName = null;
      this.pitching.agentPhone = null;
      this.pitching.agentEmail = null;
      this.listGuideline = null;
      this.pitching.notes = data.notes;
      this.openInfoModal();
    },
    convertGender(value) {
      if (value == 'true') return 'Male';
      if (value == 'false') return 'Female';
      return '';
    },
    onClickWebsite(data) {
      this.titleInformation = "Website information";
      this.infoFieldModal = JSON.parse(JSON.stringify(this.fieldWebsite));
      this.infoFieldModal.pop();
      this.pitching.agentName = null;
      this.pitching.agentPhone = null;
      this.pitching.agentEmail = null;
      this.pitching.notes = null;
      this.listGuideline = data.website;
      this.openInfoModal();
    },

    truncateDescription(text) {
      return text.length > 60 ? text.slice(0, 60) + "..." : text;
    },
    deleteWebsite(data) {
      this.pitching.listWebsite.splice(data.index, 1);
    },
    deleteContact(data) {
      this.pitching.listContact.splice(data.index, 1);
    },
    deleteDirectorContact(data) {
      this.pitching.listDirectorContact.splice(data.index, 1);
    },
    deleteJob(data) {
      this.pitching.listJob.splice(data.index, 1);
    },
    onChangePagination() {
      let query = Object.assign({}, this.$route.query);
      query.pageNumber = this.currentPage;
      query.col = this.mySortBy;
      query.sort = this.mySortDesc;
      query.rateFrom = null;
      query.rateTo = null;
      if (!this.checkRateManual) {
        this.listRateCard.forEach(element => {
          if (element.status == 0) {
            if(element.to == null && element.from == null){
              query.rateNA = true;
            }
            if (query.rateTo == null) {
              query.rateTo = element.to;
            } else if (query.rateTo != null && query.rateTo <= element.to && element.to != null) {
              query.rateTo = element.to;
            }

            if (query.rateFrom == null) {
              query.rateFrom = element.from;
            } else if (query.rateFrom != null && query.rateFrom >= element.from && element.from != null) {
              query.rateFrom = element.from;
            }
           
          }
        });
      } else {
        query.rateFrom = this.rateFrom;
        if (this.rateTo == 'Max') {
          query.rateTo = 1000;
        } else {
          query.rateTo = this.rateTo;
        }
      }
      query.search = this.search;

      // query.rateTo = Math.min(query.rateTo, this.rateTo);
      // query.rateFrom = Math.max(query.rateFrom, this.rateFrom); 
      query.searchQuality = '';
      query.searchBackground = '';
      query.searchnationality = '';
      query.searchScore = '';
      query.searchGender = '';
      this.searchGender.forEach(element => {
        query.searchGender += element + "-";
      });
      this.searchScore.forEach(element => {
        query.searchScore += element + "-";
      });
      this.searchQuality.forEach(element => {
        query.searchQuality += element + "-";
      });

      this.searchBackground.forEach(element => {
        query.searchBackground += element + "-";
      });

      this.valueNationality.forEach(element => {
        query.searchnationality += element + "-";
      });
      var kind = "";
      //this.$log(this.listKind);
      this.listKind.filter(opt => opt.status === 0).forEach(element => {
        kind += element.id + "-";
      });
      query.kind = kind;
      this.$router.push({ query: query });
    },
    queryItem() {

      let query = Object.assign({}, this.$route.query);
      this.currentPage = 1;
      query.col = this.mySortBy;
      query.sort = this.mySortDesc;
      query.pageNumber = this.currentPage;
      query.search = this.search;
      query.rateFrom = null;
      query.rateTo = null;
      if (!this.checkRateManual) {
        this.listRateCard.forEach(element => {
          if (element.status == 0) {
            if(element.to == null && element.from == null){
              query.rateNA = true;
            }
            if (query.rateTo == null) {
              query.rateTo = element.to;
            } else if (query.rateTo != null && query.rateTo <= element.to && element.to != null) {
              query.rateTo = element.to;
            }

            if (query.rateFrom == null) {
              query.rateFrom = element.from;
            } else if (query.rateFrom != null && query.rateFrom >= element.from && element.from != null) 
            {
              query.rateFrom = element.from;
            }

          
          }
        });
      } else {
        query.rateFrom = this.rateFrom;
        if (this.rateTo == 'Max') {
          query.rateTo = 1000;
        } else {
          query.rateTo = this.rateTo;
        }
      }

      //query.searchQuality = this.searchQuality;
      //query.searchnationality = this.searchnationality;
      //query.searchBackground = this.searchBackground;
      var kind = "";
      //this.$log(this.listKind);
      this.listKind.filter(opt => opt.status === 0).forEach(element => {
        kind += element.id + "-";
      });
      query.kind = kind;

      query.searchQuality = '';
      query.searchBackground = '';
      query.searchnationality = '';
      query.searchScore = '';
      query.searchGender = '';
      this.searchGender.forEach(element => {
        query.searchGender += element + "-";
      });
      this.searchScore.forEach(element => {
        query.searchScore += element + "-";
      });
      this.searchQuality.forEach(element => {
        query.searchQuality += element + "-";
      });

      this.searchBackground.forEach(element => {
        query.searchBackground += element + "-";
      });

      this.valueNationality.forEach(element => {
        query.searchnationality += element + "-";
      });
      this.closeAdvanced();
      this.$router.push({ query: query });
    },
  },
};
</script>
<style>
.truncate-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.scrollable-dropdown-menu {
  max-height: 200px;
  /* Đặt chiều cao tối đa của danh sách dropdown */
  overflow-y: auto;
  /* Bật chế độ cuộn khi danh sách vượt quá chiều cao tối đa */
}</style>
    